import _ from 'lodash';

const profileFormData = {
	"email": "jane.doe@gmail.com",
	"birthMonth": 8,
	"birthDay": 12,
	"birthYear": 1983,
	"gender": "male",
	"race": "american indian or alaskan native",
	"educationLevel": "high school",
	"householdIncome": "0-24999",
	"marriageStatus": "married",
	"city": "12355",
	"state": "CA",
	"zip": "84043",
};

const experimentRows = [
	{
	  "experimentId": "242",
	  "name": "Image Recognition",
	  "description": "This test shows a series of images and sees how well you can recall the images after seeing another set of images.",
	  "start": '2010-10-10',
	  "time": 10,
	  "incentive": 10
	},
	{
	  "experimentId": "212",
	  "name": "Changes in Pictures",
	  "description": "This test shows a set of pictures and the participant must recognize what has changed between the pictures.",
	  "start": '2010-03-10',
	  "time": 15,
	  "incentive": 20
	},
	{
	  "experimentId": "443",
	  "name": "Recognizing Patterns",
	  "description": "In this oluptatem. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Ut enim ad minima veniam, quis nostrum exercitationem",
	  "start": '2010-01-13',
	  "time": 5,
	  "incentive": 8
	},
	{
	  "experimentId": "554",
	  "name": "Fuzziness",
	  "description": "Et harum quidem rerum facilis est et expedita distinctio. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
	  "start": '2010-10-10',
	  "time": 5,
	  "incentive": 8
	},
	{
	  "experimentId": "556",
	  "name": "Color Contrast",
	  "description": "nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur",
	  "start": '2010-10-10',
	  "time": 18,
	  "incentive": 120
	},
	{
	  "experimentId": "565",
	  "name": "Pixelation",
	  "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eu",
	  "start": '2010-10-10',
	  "time": 30,
	  "incentive": 300
	},
	{
	  "experimentId": "456",
	  "name": "Incomplete Pictures",
	  "description": "Gdunt ut labore et dolore magna aliqua. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eu",
	  "start": '2010-10-10',
	  "time": 45,
	  "incentive": 200
	}
	];
	
	const myExperimentRows = [
		{
			"experimentId": "242",
			"status": "active",
			"participants": 50,
			"participantCap": 80,
			"name": "Image Recognition",
			"description": "This test shows a series of images and sees how well you can recall the images after seeing another set of images.",
			"start": '2010-10-10',
			"time": 10,
			"incentive": 10
		},
		{
			"experimentId": "212",
			"status": "inactive",
			"participants": 50,
			"participantCap": 80,
			"name": "Changes in Pictures",
			"description": "This test shows a set of pictures and the participant must recognize what has changed between the pictures.",
			"start": '2010-03-10',
			"time": 15,
			"incentive": 20
		},
		{
			"experimentId": "443",
			"status": "archived",
			"participants": 50,
			"participantCap": 80,
			"name": "Recognizing Patterns",
			"description": "In this oluptatem. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Ut enim ad minima veniam, quis nostrum exercitationem",
			"start": '2010-01-13',
			"time": 5,
			"incentive": 8
		},
		{
			"experimentId": "554",
			"status": "active",
			"participants": 50,
			"participantCap": 80,
			"name": "Fuzziness",
			"description": "Et harum quidem rerum facilis est et expedita distinctio. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
			"start": '2010-10-10',
			"time": 5,
			"incentive": 8
		},
		{
			"experimentId": "556",
			"status": "active",
			"participants": 50,
			"participantCap": 80,
			"name": "Color Contrast",
			"description": "nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur",
			"start": '2010-10-10',
			"time": 18,
			"incentive": 120
		},
		{
			"experimentId": "565",
			"status": "active",
			"participants": 50,
			"participantCap": 80,
			"name": "Pixelation",
			"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eu",
			"start": '2010-10-10',
			"time": 30,
			"incentive": 300
		},
		{
			"experimentId": "456",
			"status": "active",
			"participants": 50,
			"participantCap": 80,
			"name": "Incomplete Pictures",
			"description": "Gdunt ut labore et dolore magna aliqua. Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eu",
			"start": '2010-10-10',
			"time": 45,
			"incentive": 200
		}
		];

const summaryData = {
	participants: 123,
	averageTime: 33,
	quitters: 42,
	chartData: [
		{name: 'Question 1', value:20},
		{name: 'Question 2', value:21},
		{name: 'Question 3', value:35},
		{name: 'Question 4', value:32},
		{name: 'Question 5', value:66},
		{name: 'Question 6', value:19},
		{name: 'Question 7', value:12},
		{name: 'Question 8', value:24},
		{name: 'Question 9', value:21},
		{name: 'Question 10', value:20},
	]
}

const detailsForm = {
	status: 'inactive',
	title: 'Image Recognition',
	description: 'Find the main color for a number of pictures.',
	time: 5,
	rules:[
		{
			"field": "gender",
			"operator": "=",
			"value": "male"
		},
		{
			"field": "birthYear",
			"operator": ">",
			"value": 2000
		},
		{
			"field": "marriageStatus",
			"operator": "=",
			"value": "never married"
		}
	]
};

const experimentData = {
	screens:{
		id:'Experiment',
		isGroup: true,
		children:[
			{id:'Introduction', elements:[]},
			{
				id:'Image Test',
				isGroup: true,
				children:[
					{id:'Ready'},
					{id:'Show'},
					{id:'Request Answer'},
				]
			},
			{
				id:'Image Test Level 2',
				isGroup: true,
				children:[
					{id:'Ready'},
					{id:'Show'},
					{
						id:'Request Answer',
						isGroup: true,
						children:[
							{id:'Request Answer'},
							{id:'Request Reason Why'},
						]
					},
				]
			},
			{id:'Conclusion'}
		]
	}
};


export default class Debugger {
	constructor(app) {
		this.app = app;
	}

	useGuest() {
		this.app.user = null;
	}

	useParticipant() {
		this.app.user = {username: 'jane@gmail.com'};
	}

	useResearcher() {
		this.app.user = {username: 'jane@gmail.com', isResearcher:true}; 
	}

	loadProfileData() {
		this.app.profileForm = { ...this.app.profileForm, ...profileFormData };
	}

	loadExperimentsData() {
		this.app.viewExperimentsForm = { ...this.app.viewExperimentsForm, rows: experimentRows };
	}

	loadManageExperimentsData() {
		this.app.manageExperimentsForm = { ...this.app.manageExperimentsForm, rows: myExperimentRows };
	}

	loadExperimentDetailsData(){
		this.app.detailsForm = {...this.app.detailsForm, ...detailsForm};
		this.app.summaryData = { ...this.app.summaryData, ...summaryData };
	}

	loadEditExperimentData(){
		this.app.experiment.data = _.cloneDeep(experimentData);
	}
}


// WEBPACK FOOTER //
// ./src/models/Debugger.js